import React, { Fragment } from 'react';

import withAuthServerSideProps from '@/libs/auth';

import { PageLayout, PlatForm } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTag from '@/components/ui/MetaTag';

const ConsignPolicyPage = () => {
  return (
    <Fragment>
      <MetaTag title="Chính sách mua bán/ký gửi sản phẩm" description="Chính sách mua bán/ký gửi sản phẩm" />
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10">
        <div className="tw-flex tw-flex-col tw-px-0 lg:tw-px-10 tw-text-base tw-leading-7">
          <h1 className="tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase">
            Chính sách mua bán/ký gửi sản phẩm
          </h1>
          <div className="tw-flex tw-flex-col tw-gap-y-2">
            <h3 className="tw-font-bold tw-text-lg tw-mt-3">Bản thông tin chế độ thu sản phẩm Thanh lý/Ký gửi:</h3>
            <div className="tw-flex tw-items-center tw-justify-center tw-mt-3">
              <table className="tw-border tw-text-base">
                <thead>
                  <tr className="tw-text-primary-main tw-border-b tw-bg-secondary-70/[0.06]">
                    <th className="tw-px-[10px] tw-py-2 tw-w-58 tw-border-r">Giá trị sản phẩm giao dịch</th>
                    <th className="tw-px-[10px] tw-py-2 tw-w-58 tw-border-r">% phí ký gửi SP ngoài</th>
                    <th className="tw-px-[10px] tw-py-2 tw-w-58 tw-border-r">% phí ký gửi SP An Thư</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 1 triệu - 99 triệu</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">18%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">15%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 100 triệu - 199 triệu</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">15%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">13%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 200 triệu - 499 triệu</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">13%</td>
                    <td className="tw-py-1 tw-border-r">10%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 500 triệu - 999 triệu</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">10%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">10%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Từ 1 tỷ trở lên</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">8%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">8%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Sản phẩm Ngọc Trai/Đá quý</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">20%</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">20%</td>
                  </tr>
                  <tr className="tw-text-center tw-border-b">
                    <td className="tw-py-1 tw-border-r tw-text-left tw-p-[10px]">Sản phẩm không thu đổi</td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]"></td>
                    <td className="tw-py-1 tw-border-r tw-p-[10px]">50%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h3 className="tw-font-bold tw-text-lg tw-mt-3">Lưu ý và điều kiện chung:</h3>
            <ul>
              <li>
                - Khách hàng đảm bảo sản phẩm dùng để bán/ký gửi phải minh bạch và hợp pháp về nguồn gốc cũng như quyền
                trao đổi/ ký gửi. Trong trường hợp xảy ra tranh chấp về quyền sở hữu sản phẩm, trách nhiệm hoàn toàn
                thuộc về Khách hàng.
              </li>
              <li>
                - Khi giao dịch tại An Thư khách hàng phải cung cấp CMND/CCCD/Hộ chiếu/Bằng lái xe….để lưu thông tin
                giao dịch.
              </li>
              <li>
                - Thông tin trên Phiếu thông tin sản phẩm là một phần không thể thiếu và là cơ sở để đối chiếu nếu có
                khách hàng đổi ý muốn lấy lại sản phẩm đã Ký gửi.{' '}
              </li>
              <li>
                Sản phẩm đã nhận tiền thanh lý sẽ thuộc quyền sở hữu và quyết định của An Thư. Nếu sau khi nhận tiền
                thanh lý, Khách hàng muốn lấy lại sản phẩm và An Thư vẫn đang sở hữu sản phẩm đó thì Khách hàng phải
                hoàn trả khoản tiền thanh lý đã nhận và trả thêm 10% giá trị giao dịch của sản phẩm thanh lý. An Thư sẽ
                bàn giao sản phẩm trong vòng 48h làm việc kể từ thời điểm nhận đủ thanh toán từ Khách hàng. Trong trường
                hợp Khách hàng không thực hiện thanh toán toàn bộ giá trị nêu trên, An Thư bảo lưu quyền từ chối hoàn
                trả tài sản cho Khách hàng và Khách hàng đồng ý không có bất cứ khiếu nại nào liên quan đến việc từ chối
                hoàn trả nêu trên.
              </li>
              <li>
                - Sản phẩm Ký gửi sẽ được An Thư bảo quản, vệ sinh làm mới. Nếu hết thời gian Ký gửi sản phẩm vẫn chưa
                bán được và khách hàng muốn lấy lại thì sẽ dựa trên Phiếu thông tin sản phẩm để bàn giao lại cho Khách
                hàng.
              </li>
              <li>
                - Trong thời gian Ký gửi, An Thư sẽ toàn quyền quyết định liên quan Sản phẩm. Nếu khách hàng muốn lấy
                lại Sản phẩm trước thời hạn sẽ <strong>phải</strong> chịu thêm mức phí là 5% dựa trên giá trị thỏa thuận
                Ký gửi trước đó.
                <strong>
                  &nbsp;Đồng thời An Thư sẽ bàn giao sản phẩm trong vòng 48h kể từ thời điểm khách hàng hoàn thành nghĩa
                  vụ thanh toán đối với An Thư.
                </strong>
              </li>
              <li>
                - Trường hợp thời gian ký gửi kết thúc mà Sản phẩm vẫn chưa bán, nếu Khách hàng không gửi thông tin tiếp
                tục hay muốn lấy lại sản phẩm trước ngày kết thúc thời gian ký gửi thì mặc định thời gian ký gửi sẽ được
                gia hạn bằng với thời gian ban đầu ghi trên Phiếu.
              </li>
              <li>
                - Giá trị sản phẩm khi định giá chỉ có giá trị trong 24h kể từ lúc An Thư gửi mức giá. Sau thời gian
                trên giá trị sản phẩm thanh lý/ký gửi có thể thay đổi hoặc An Thư có quyền từ chối nhận sản phẩm.
              </li>
              <li>
                - An Thư có trách nhiệm thanh toán phần giá trị còn lại cho Khách hàng khi ký gửi sản phẩm trong vòng
                <strong>&nbsp;72h (03 ngày)</strong> kể từ thời điểm sản phẩm ký gửi được bán ra và An Thư nhận được
                toàn bộ tiền thanh toán từ bên mua sản phẩm.
              </li>
              <li>
                - Mọi thông tin trao đổi khi thỏa thuận Thanh lý/Ký gửi là bảo mật. Khách hàng và An Thư không cung cấp
                cho bên thứ ba. Nếu xảy tra tranh chấp bảo mật thông tin, bên không tuân thủ sẽ chịu hoàn toàn trách
                nhiệm đền bù 100% giá trị giao dịch theo thỏa thuận.
              </li>
              <li>
                - Trường hợp khách hàng ký gửi Sản phẩm mua từ An Thư sẽ có % phí ký gửi tốt hơn % bán lại sản phẩm theo
                chế độ An Thư, với điều kiện thời gian ký gửi không ít hơn <strong>30 ngày</strong>.
              </li>
              <li>
                - Phiếu sẽ được xuất thành 2 bản. Bản chính An Thư giữ, bản photo có dấu đóng An Thư sẽ do khách hàng
                giữ. Trường hợp xảy ra tranh chấp giữa Khách hàng và An Thư, phiếu này sẽ được dùng làm cơ sở, bằng
                chứng để giải quyết tranh chấp.
              </li>
              <li>
                - Trong trường hợp xảy ra tranh chấp ngoài các điều kiện trên, hai bên sẽ ưu tiên thương lượng, hoà giải
                và các bên có quyền khởi kiện tại Toà án có thẩm quyền để yêu cầu giải quyết tranh chấp.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, query }: GetServerSidePropsContext) => {
    const platform = query?.platform || PlatForm.Web;
    return {
      props: {
        layout: PageLayout.New,
        platform,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default ConsignPolicyPage;
